<template>
	<div class="banner-wrap">
		
	
	<div class="banner">
		<el-carousel indicator-position="outside" height="482px">
		    <el-carousel-item v-for="item in 4" :key="item">
				<img src="../../assets/912x482.jpg" >
		    </el-carousel-item>
		  </el-carousel>
	</div>
	
	</div>
</template>

<script>
	export default {
		name: 'q-banner',
		props: {
			msg: String
		},
		data() {
			return {
			
			}
		},
	
		
		mounted() {
			
		},
		methods: {
			
		}
		
		
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="less">
	.banner-wrap{
		height: 566px;
		
		.banner{
			width: 938px;
			height: 508px;
			border: 13px solid #FFFFFF;
			margin: 0 auto;
			-webkit-box-sizing: border-box;
			-moz-box-sizing: border-box;
			box-sizing: border-box;
			position: relative;
		}
		.el-carousel,
		.el-carousel__item{
			height: 482px;
			width: 912px;
		}
		.el-carousel--horizontal{
			overflow: visible;
		}
		.el-carousel__container{
			overflow: hidden;
		}
		.el-carousel__indicators--outside{
				position: absolute;
				width: 100%;
				left: 0;
				float: left;
				height: 30px;
				top: 106%;text-align: center;
		}
		.el-carousel__indicator--horizontal{
			width: 66px;
			height: 16px;
			background: #FFFFFF;
			opacity: 0.2;
			border-radius: 8px;
			padding: 0;margin: 0 8px;
			.el-carousel__button{
				opacity: 0;
				height: 16px;
				width: 100%;
				border-radius: 30px;
				
			}
			&.is-active{
				opacity: 1;
				background: #fff;
				.el-carousel__button{
					opacity: 0;
					height: 16px;
					width: 100%;
					border-radius: 30px;
				}
			}
		}
	
	
	}
</style>
